import React from 'react';
import { CoreAPI, useIdentity } from '../../core';
import { useScale } from '../../stage/hooks';

export const StageScaleView = React.forwardRef<
    HTMLDivElement,
    {
        originIndex: number;
        children?: React.ReactNode;
        style?: React.CSSProperties;
    }
>(({ originIndex, children, style }, ref) => {
    const scale = useScale();
    const identity = useIdentity();
    const size = CoreAPI(identity).getSize(originIndex);

    return (
        <div
            ref={ref}
            style={{
                width: size.width,
                height: size.height,
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) scale(${scale})`,
                ...style,
            }}
        >
            {children}
        </div>
    );
});
